var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_771",
    "data-name": "Rettangolo 771",
    width: 22,
    height: 22,
    transform: "translate(770 35)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_etichetta",
    "data-name": "icona etichetta",
    transform: "translate(-770 -35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_31",
    "data-name": "Gruppo di maschere 31",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_etichetta-2",
    "data-name": "icona etichetta",
    transform: "translate(782.5 33) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1007",
    "data-name": "Raggruppa 1007",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1006",
    "data-name": "Raggruppa 1006",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_214",
    "data-name": "Tracciato 214",
    d: "M11.016,7.114,8.128,3.463A3.109,3.109,0,0,0,6.144,2.322V.439a.439.439,0,0,0-.878,0V2.322A3.051,3.051,0,0,0,3.287,3.463L.391,7.118A1.829,1.829,0,0,0,0,8.242V19.209A1.8,1.8,0,0,0,1.8,21h7.79a1.8,1.8,0,0,0,1.813-1.782V8.242A1.851,1.851,0,0,0,11.016,7.114ZM5.705,6.6A1.277,1.277,0,1,1,4.428,7.878,1.276,1.276,0,0,1,5.705,6.6Zm4.828,12.609a.92.92,0,0,1-.935.913H1.813a.92.92,0,0,1-.935-.913V8.242a.921.921,0,0,1,.2-.579L3.972,4.007a2.2,2.2,0,0,1,1.295-.794V5.767a2.156,2.156,0,1,0,.878,0V3.213a2.218,2.218,0,0,1,.522.176,2.188,2.188,0,0,1,.768.619l2.9,3.651a.942.942,0,0,1,.2.584Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1008",
    "data-name": "Raggruppa 1008",
    transform: "translate(2.677 16.019)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_139",
    "data-name": "Rettangolo 139",
    width: 6.056,
    height: 0.527,
    rx: 0.263,
    transform: "translate(0 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_140",
    "data-name": "Rettangolo 140",
    width: 6.056,
    height: 0.527,
    rx: 0.263,
    transform: "translate(0 1.229)",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.6253e8c5709059b2c89cdef58b5cafef.svg";
export { ForwardRef as ReactComponent };